document.addEventListener("DOMContentLoaded", function () {
    const host = window.location.host;
    const swatches = document.querySelectorAll('.swatch-element');
    const soldOutBadges = document.querySelector('.price__badge--sold-out');
    const saleBadges = document.querySelector('.price__badge--sale');
    const collectionsale = document.querySelector('.product-index-inner .sale-item');
    const collectionsoldout = document.querySelector('.product-index-inner .so.icn');

     // New elements for AU/NZ instock text
    const instockTextAU = document.querySelector(".instock-text.au");
    const instockTextNZ = document.querySelector(".instock-text.nz");

    swatches.forEach((swatch) => {
        const variantId = swatch.getAttribute('data-variant-id');
        const variantData = window.variantStockData?.[variantId];

        if (!variantData) return; // skip if no data for this variant

        let stock = 0;

        if (host.includes('.co.nz')) {
            stock = variantData.market_nz_in_stock;
        } else {
            stock = variantData.market_au_in_stock;
        }

        // Convert null/undefined/empty string safely to a number
        const stockValue = parseInt(stock) || 0;

        // Only mark as soldout if metafield exists and value is 0
        if (stock !== "" && stockValue === 0) {
            swatch.classList.add('soldout');
            if (soldOutBadges) soldOutBadges.style.display = "block";
            if (collectionsoldout) collectionsoldout.style.display = "block";
            if (saleBadges) saleBadges.style.display = "none";
            if (collectionsale) collectionsale.style.display = "none";

        } else {
            swatch.classList.remove('soldout');

            if (soldOutBadges) soldOutBadges.style.display = "none";
            if (saleBadges) saleBadges.style.display = "block";
            if (collectionsoldout) collectionsoldout.style.display = "none";
            if (collectionsale) collectionsale.style.display = "block";
        }
    });
});